// todo: hard code for now, need to confirm with FreePlato

export default {
  RouteWhiteList: ['403', 'productBranchDecision', 'login', 'init_plat', 'home'],
  FlowDesignDetailRoutes: ['appFlowDesign', 'microFlowDesign', 'AddComponent'],
  SystemDetailRoutes: ['basic_sys_detail', 'app_sys_detail', 'app_sys_version', 'basicSysVersion'],
  //DesKey: 'DqfHO0CRJmEHy9PCkqiUYptSINxk00Nk',
  RejectTypes: {
    InUse: 'inUse',
    Cancel: 'cancel'
  },
  Login: {
    Url: '/login',
    IsFirstLogin: 'isFirstLogin'
  },
  Pagination: {
    PageSize: 10
  },
  common: {
    ListShowType: 'listShowType',
    FlowChartsTheme: 'flowChartsTheme'
  },
  Events: {
    ServiceDesignUpdated: 'serviceDesignUpdated',
    ComponentDesignUpdated: 'componentDesignUpdated',
    TabCacheRemoved: 'tabCacheRemoved',
    RemoveCurrentTab: 'removeCurrentTab',
    RemoveAllKeepAliveCache: 'removeAllKeepAliveCache',
    Save: 'save',
    NodeClick: 'nodeClick',
    UpdateTree: 'update-tree',
    GetInputs: 'get-inputs',
    GetConditions: 'get-conditions',
    GetOutputs: 'get-outputs',
    ChangeToDetail: 'change-to-detail',
    UpdateSelectedNode: 'update:selectedNode',
    ChangeOutputs: 'changeOutputs',
    ChangeInputs: 'changeInputs',
    ListNameCodeSubmit: 'listNameCodeSubmit',
    HandleOperation: 'handleOperation',
    Change: 'change',
    Add: 'add',
    Edit: 'edit',
    Delete: 'delete',
    Scan: 'scan',
    ModuleRelease: 'moduleRelease',
    ApplicationRelease: 'applicationRelease',
    ChangeOptions: 'changeOptions',

    StartNodeClicked: 'startNodeClicked',
    EndNodeClicked: 'endNodeClicked',
    TransactionNodeClicked: 'transactionNodeClicked',
    NormalNodeDoubleClicked: 'normalNodeDoubleClicked',
    ServiceNodeDoubleClicked: 'serviceNodeDoubleClicked',
    NormalNodeClicked: 'normalNodeClicked',
    ServiceNodeClicked: 'serviceNodeClicked',
    LoopBlockClicked: 'loopBlockClicked',
    BranchBlockClicked: 'branchBlockClicked',
    ConcurrencyBlockClicked: 'concurrencyBlockClicked',
    RealConcurrencyBlockClicked: 'realConcurrencyBlockClicked',
    NormalLinkClicked: 'normalLinkClicked',
    TransactionLinkClicked: 'transactionLinkClicked',
    SelectionCancelled: 'selectionCancelled',
    CanvasClicked: 'canvasClicked',
    NormalLinkDrawn: 'normalLinkDrawn',
    TransactionLinkDrawn: 'transactionLinkDrawn',
    ObjectDraggedIn: 'objectDraggedIn',
    SelectionDeleted: 'selectionDeleted',
    BlockNodeClicked: 'blockNodeClicked',
    TableNodeClicked: 'tableNodeClicked',
    GroupClicked: 'groupClicked'
  },
  Regex: {
    GeneralName: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
    roleAndOrganizationName: /^[A-Za-z0-9\u4e00-\u9fa5\(\)\_\-]+$/,
    specialStr: /^[\(\)\_\-]+$/,
    Port: /^[0-9]{4,5}$/,
    GeneralCode: /^[a-z][A-Za-z0-9]+$/,
    UnderScoreCode: /^(?!_)(?!.*?_$)(?!.*[_]{2})[A-Z_]+$/,
    ListCode: /^list[A-Za-z][A-Za-z0-9]+$/,
    ObjectCode: /^object[A-Za-z][A-Za-z0-9]+$/,
    DataFile: /(.data)$/i,
    enumIntCode: /^(-|\+)?\d+$/,
    enumStrCode: /^[A-Za-z0-9]+$/,
    EnvCode: /^[A-Za-z][A-Za-z0-9]+$/,
    MavenUrl1: /http:\/\/([\w]+\.)+[\w]+(\/[\w+\/?])?\S/,
    MavenUrl: /\bhttp[s]{0,1}:\/\/[\w.-]+\/?\b/,


  },
  subsystem: {
    APP: 'app', 
    //聚合
    MODULE: 'module'
    //基础
  },
  PermissionStatus: {
    Collapsed: '2',
    Disabled: '1',
    Enabled: '0'
  },
  RouteNames: {
    Dtaas: 'Dtaas',
    Home: 'Home',
    DictManagement: 'DictManagement',
    BasicTypeDetail: 'basicTypeDetail',
    MetadataDetail: 'metadataDetail',
    AddDictAndList: 'AddDictAndList',
    AddObject: 'AddObject',
    EditObject: 'EditObject',
    ViewObject: 'ViewObject',
    HeaderAddDict: 'headerAddDict',
    AddDict: 'AddDict',
    EditDict: 'EditDict',
    ViewDict: 'ViewDict',
    AddList: 'AddList',
    EditList: 'EditList',
    ListDetail: 'listDetail',
    AddEnum: 'AddEnum',
    EditEnum: 'EditEnum',
    EnumDetail: 'enumDetail',
    AddMeta: 'AddMeta',
    EditMeta: 'EditMeta',
    ViewMeta: 'ViewMeta',
    ComponentDesign: 'ComponentDesign',
    ComponentCodeCharts: 'ComponentCodeCharts',
    AddListDirectly: 'AddListDirectly',
    AddComponent: 'AddComponent',
    ComponentDetail: 'componentDetail',
    MicroServiceDetail: 'microDetail',
    MicroServiceDesign: 'microFlowDesign',
    AppServiceDetail: 'appServiceDetail',
    AppServiceDesign: 'appFlowDesign',
    SimpleServiceDesign: 'SimpleServiceDesign',
    SystemManagement: 'systemManagement',
    DatabaseDesignTable: 'dataModeling',
    DataSourceTable: 'datasourceTable',
    ServiceRelease: 'ServiceRelease',
    MicroService: 'microService',
    AppService: 'appService',
    ApplicationExport: 'ApplicationExport',
    MybatisExport: 'MybatisExport',
    ServiceMonitorSummary: 'ServiceMonitorSummary',
    ServiceMonitorFilter: 'ServiceMonitorFilter',
    ServiceMonitorDetail: 'ServiceMonitorDetail',
    ProductManagement: 'proManagement',
    UsersManagement: 'usersManagement',
    UserAdd: 'sysUserAdd',
    UserDetail: 'userDetail',
    UserList: 'userList',
    RolesManagement: 'rolesManagement',
    RoleDetail: 'roleDetail',
    ServiceTest: 'ServiceTest',
    ProductBranchDecision: 'ProductBranchDecision',
    MenuManagement: 'menuManagement',
    DictItemManagement: 'dictItemManagement',
    checkObjectCodeIsExist: 'checkObjectCodeIsExist',
    SubsystemVersionAdd: 'subsystemVersionAdd',
    SubsystemVersionEdit: 'subsystemVersionEdit',
    MessageStructure: 'messageStructure',
    SystemDownload: 'systemDownload',
    AppVersionManagement: 'appVersionManagement',
    ModuleVersionManagement: 'moduleVersionManagement',
    ProjectManageErrorcode: 'errorcode',
    AppUnitManagement: 'appUnitManage',
    ModuleUnitManagement: 'unitManagement',
    WorkbenchErrorcode: 'workbenchErrorcode',
    ProjectVersionManagement:"systemVersion" ,
    ProjectVersionView:"viewAssociatedSubsystems" 


  },
  http: {
    Methods: {
      Post: 'POST',
      Get: 'GET'
    },
    ResponseTypes: {
      Blob: 'blob'
    },
    HeaderKeys: {
      ContentType: 'content-type',
      ContentDisposition: 'content-disposition'
    },
    HeaderValues: {
      ApplicationJson: 'application/json'
    },
    InternalCodes: {
      OK: '00000000',
      NotLogin: 'ES1300032',
      TokenExpired: 'ES1300033',
      ErrorVersion: 'ES1300011',
      ErrorCodes: ['ES1300090', 'ES1300091']
    },
    SkipGlobalErrorHandler: { 'Skip-Global-Error-Handler': true }
  },
  PropTypes: {
    List: 'java.util.List',
    Obj: 'java.lang.Object'
  },
  ServiceDesign: {
    SessionKey: 'SimpleServiceDesignSession',
    Search: {
      microService: 'microServiceSearchCriteria',
      appService: 'appServiceSearchCriteria'
    },
    CurrentPage: {
      microService: 'microServiceListCurrentPage',
      appService: 'appServiceListCurrentPage'
    },
    Status: {
      Stash: 'stash',
      Save: 'save',
      Pending: 'pending'
    }
  },
  myDesign: {
    Search: {
      moduleService: 'microServiceSearch',
      appService: 'appServiceSearch',
      component: 'componentSearch'
    },
    CurrentPage: {
      moduleService: 'microServiceListCurPage',
      appService: 'appServiceListCurPage',
      component: 'componentListCurPage'
    },
  },
  FlowCharts: {
    // startNode和EndNode的key值固定1，0；
    StartNodeKey: 1,
    EndNodeKey: 0,
    NoTypes: {
      MsNo: 'msNo',
      AsNo: 'asNo'
    },
    Tactics: {
      Break: 'break',
      Continue: 'continue'
    },
    LoopParameters: {
      Input: 'input',
      Output: 'output',
      AggregateInput: 'aggregateInput'
    },
    ServiceType: {
      MicroService: 'microService',
      AppService: 'appService',
      Reverse: 'reverse'
    },
    ActualServiceTypes: {
      microService: 'microService',
      appService: 'appService',
      reverse: 'microService'
    },
    TransactionTypes: {
      Local: 'LOCAL',
      SAGA: 'SAGA'
    },
    NodeText: {
      Component: 'Component',
      Service: 'Service',
      AppService: 'App Service'
    },
    Types: {
      StartNode: 'startNode',
      EndNode: 'endNode',
      TransactionNode: 'transactionNode',
      NormalNode: 'normalNode',
      ServiceNode: 'serviceNode',
      LoopBlock: 'loopBlock',
      ConcurrencyBlock: 'concurrencyBlock',
      RealConcurrencyBlock: 'realConcurrencyBlock',
      BranchBlock: 'branchBlock',
      NormalLink: 'normalLink',
      TransactionLink: 'transactionLink',
      SelectNode: 'selectNode',
      DeleteNode: 'deleteNode',
      UpdateNode: 'updateNode',
      InsertNode: 'insertNode',
      Group: 'group'
    },
    ToolTips: {
      Transaction: '事务',
      Component: '组件',
      Service: '服务',
      AppService: '组合服务',
      LoopBlock: '循环(串行)控制块',
      ConcurrencyBlock: '循环(并行)控制块',
      RealConcurrencyBlock: '并发控制块',
      BranchBlock: '分支控制块'
    }
  },
  ServiceTest: {
    CacheKey: 'ServiceTestConfig'
  },
  project:{
    versionManagement:'systemversion'
  },
  SystemManagement: {
    Types: {
      Module: 'module',
      App: 'app',
      OnePack: 'onePack',
      BatchPack: 'batchPack',
      release: 'release',
      snapshots: 'snapshots',
      Component: "component"
    },
    ComponentTypes: {
      Application: 'Application',
      Module: 'Module'
    },
    SystemSessionKey: 'SystemHeaderSession',
    ModuleSessionKey: 'ModuleHeaderSession',
    frameworkType: [
      { label: 'REST', value: '1' },
      { label: 'Dubbo', value: '2' },
      { label: 'SOFARPC', value: '3' }
    ]
  },
  ServiceRelease: {},
  DataSource: {
    mysql: {
      driver: 'com.mysql.cj.jdbc.Driver',
      connectionTemplate: 'jdbc:mysql://localhost:3306/dbname'
    },
    sqlserver: {
      driver: 'com.microsoft.sqlserver.jdbc.SQLServerDriver',
      connectionTemplate: 'jdbc:sqlserver://localhost:1433;databasename=dbname'
    },
    postgresql: {
      driver: 'org.postgresql.Driver',
      connectionTemplate: 'jdbc:postgresql://localhost:5432/dbname'
    },
    oracle: {
      driver: 'oracle.jdbc.driver.OracleDriver',
      connectionTemplate: 'jdbc:oracle:thin:@localhost:1521:dbname'
    },
    dm: {
      driver: 'dm.jdbc.driver.DmDriver',
      connectionTemplate: 'jdbc:dm://localhost:5236'
    }
  },
  DictDesign: {
    javaType: [
      { value: 'java.lang.Integer', dictDbConstraintType: 'int' },
      { value: 'java.lang.String', dictDbConstraintType: 'varchar' },
      { value: 'java.lang.Long', dictDbConstraintType: 'long' },
      { value: 'java.util.Date', dictDbConstraintType: 'date' },
      { value: 'java.math.BigDecimal', dictDbConstraintType: 'float' }
      // { value: 'java.math.BigInteger', dictDbConstraintType: 'int' }
    ],
    enumJavaType: [
      { value: 'java.lang.Integer', dictDbConstraintType: 'int' },
      { value: 'java.lang.String', dictDbConstraintType: 'varchar' }
    ],
    javaTypeSelect: [
      { name: 'Integer', value: 'java.lang.Integer' },
      { name: 'String', value: 'java.lang.String' },
      { name: 'Long', value: 'java.lang.Long' },
      { name: 'Date', value: 'java.util.Date' },
      { name: 'BigDecimal', value: 'java.math.BigDecimal' },
      { name: 'BigInteger', value: 'java.math.BigInteger' }
    ],
    sqlType: [
      { value: 'varchar' },
      { value: 'char' },
      { value: 'int' },
      { value: 'timestamp' },
      { value: 'float' }
    ]
  },
  ServiceMonitor: {},
  Roles: {
    1: '超级管理员',
    2: '产品管理员',
    3: '开发人员',
    4: '技术经理',
    Admin: '1',
    ProductAdmin: '2',
    Developer: '3',
    TechManager: '4'
  },
  UsersManagement: {
    Token: 'token',
    SessionKey: 'UserListSession'
  },
  ProjectManagement: {
    LastDecision: 'lastDecision',
    sysNo: 'sysNo'
  },
  keywords: [
    'version',
    'raceId',
    'nodeId',
    'serviceFramework',
    'code',
    'message',
    'flowNodeErrorCode',
    'flowNodeErrorMsg',
    'private',
    'public',
    'abstract',
    'class',
    'extends',
    'final',
    'implements',
    'interface',
    'native',
    'new',
    'static',
    'strictfp',
    'synchronized',
    'transient',
    'volatile',
    'break',
    'continue',
    'return',
    'do',
    'while',
    'if',
    'else',
    'for',
    'instanceof',
    'switch',
    'case',
    'default',
    'try',
    'catch',
    'throw',
    'throws',
    'import',
    'package',
    'boolean',
    'byte',
    'char',
    'double',
    'float',
    'int',
    'long',
    'short',
    'null',
    'true',
    'false',
    'super',
    'this',
    'void',
    'goto',
    'const',
    'traceId',
    'transSeq',
    'expandMsg',
  ],
  msgStructNodekeywords: [
    'sysReqHead',
    'sysRspHead'
  ],
  BMP: {
    //业务域域组
    filed_types: {
      1: '文本类 (TEXT)',
      2: '数值类 (NUMBER)',
      3: '金额类 (AMOUNT)',
      4: '百分比类 (PERCENT)',
      5: '日期类 (DATE)',
      6: '时间类 (TIME)',
      7: '日期时间类 (DATETIME)',
      8: '标识类 (FLAG)',
      9: '编码类 (CODE)',
      10: '代码类 (CODING)',
      11: '非结构化类 (UNSTRUCTURED)'
    },

    dict_types: {
      "1": "java.lang.String",
      "2": "java.lang.Integer",
      "3": "java.math.BigDecimal",
      "4": "java.math.BigDecimal",
      "5": "java.util.Date",
      "6": "java.util.Date",
      "7": "java.util.Date",
      "8": "java.lang.String",
      "9": "java.lang.String",
      "10": "java.lang.String",
      "11": "java.lang.String"
    }
  },
  IS_INIT_PLAT:'is_init_plat',
  //平台是否初始化

};
